// src/hooks/useProveedores.js
import { useState, useEffect } from "react";
import { collection, addDoc, updateDoc, deleteDoc, doc, onSnapshot, query, orderBy, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import toast from "react-hot-toast";

export function useProveedores(tipo = "materiales") {
  const [proveedores, setProveedores] = useState([]);
  const [loading, setLoading] = useState(true);
  const COL = tipo === "transporte" ? "transportistas" : "proveedores";

  useEffect(() => {
    const q = query(collection(db, COL), orderBy("nombre"));
    return onSnapshot(q, snap => {
      setProveedores(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      setLoading(false);
    });
  }, [COL]);

  const crear = async (datos) => {
    try {
      await addDoc(collection(db, COL), { ...datos, creadoEn: serverTimestamp(), activo: true });
      toast.success(`✅ ${tipo === "transporte" ? "Transportista" : "Proveedor"} creado`);
    } catch {
      toast.error("Error al crear. Intenta nuevamente.");
    }
  };

  const actualizar = async (id, datos) => {
    try {
      await updateDoc(doc(db, COL, id), { ...datos, actualizadoEn: serverTimestamp() });
      toast.success("Actualizado correctamente");
    } catch {
      toast.error("Error al actualizar. Intenta nuevamente.");
    }
  };

  const eliminar = async (id) => {
    try {
      await deleteDoc(doc(db, COL, id));
      toast.success("Eliminado");
    } catch {
      toast.error("Error al eliminar. Intenta nuevamente.");
    }
  };

  return { proveedores, loading, crear, actualizar, eliminar };
}
